export enum APPROVAL {
  PENDING = 1,
  REVISI,
  REJECT,
  APPROVE
}
